const DEFAULT_API_BASE = 'http://localhost:3001/api';

function normalizeApiBase(value) {
  const base = String(value || '').trim() || DEFAULT_API_BASE;
  return base.replace(/\/+$/, '');
}

export const API_BASE = normalizeApiBase(process.env.REACT_APP_API_BASE_URL);

export function apiUrl(path = '') {
  const suffix = String(path || '');
  if (!suffix) return API_BASE;
  return `${API_BASE}${suffix.startsWith('/') ? suffix : `/${suffix}`}`;
}
